// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y16Q","content":"styles_content__2h4Om","tableWrap":"styles_tableWrap__35tUA"};